import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useNavigate } from 'react-router-dom';
import {
  Content,
  Link,
  Page,
  useSupportConfig,
} from '@backstage/core-components';
import { GraphRunnerGame } from './graphRunnerGame/GraphRunnerGame';
import { RELATION_PATCH_GAME_TITLE } from './graphRunnerGame/gameCopy';

interface NotFoundErrorPageProps {
  supportUrl?: string;
}

const useStyles = makeStyles(
  theme => ({
    content: {
      minHeight: 0,
      padding: theme.spacing(8, 4),
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(1.5, 2),
      },
    },
    header: {
      textAlign: 'center',
      flexShrink: 0,
      marginBottom: theme.spacing(5),
    },
    title: {
      marginBottom: theme.spacing(0.5),
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.h4.fontSize,
      },
    },
    subtitle: {
      color: theme.palette.text.secondary,
    },
    gameWrapper: {
      flex: '1 1 auto',
      minHeight: 0,
      display: 'flex',
      justifyContent: 'center',
      overflow: 'hidden',
    },
    footer: {
      flexShrink: 0,
      textAlign: 'center',
      marginTop: theme.spacing(1.5),
    },
  }),
  { name: 'BackstageErrorPage' },
);

export function NotFoundErrorPage(props: NotFoundErrorPageProps) {
  const { supportUrl } = props;
  const classes = useStyles();
  const navigate = useNavigate();
  const support = useSupportConfig();

  return (
    <Page themeId="home">
      <Content stretch className={classes.content}>
        <div className={classes.header}>
          <Typography variant="h4" className={classes.title}>
            404 - This page has no relationship to our graph
          </Typography>
          <Typography variant="body1" className={classes.subtitle}>
            The page you're looking for doesn't exist. While you're here, feel
            free to play {RELATION_PATCH_GAME_TITLE} below! Use your hand to fly
            through broken relationships and patch them back together.
          </Typography>
        </div>

        <div className={classes.gameWrapper}>
          <GraphRunnerGame />
        </div>

        <Typography variant="body2" className={classes.footer}>
          <Link to="#" data-testid="go-back-link" onClick={() => navigate(-1)}>
            Go back
          </Link>{' '}
          or please <Link to={supportUrl || support.url}>contact support</Link>{' '}
          if you think this is a bug.
        </Typography>
      </Content>
    </Page>
  );
}
